/* unplugin-vue-components disabled */import script from "./phone-action.vue?vue&type=script&setup=true&lang=ts"
export * from "./phone-action.vue?vue&type=script&setup=true&lang=ts"

import "./phone-action.vue?vue&type=style&index=0&id=796002eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796002eb"]])

export default __exports__